import { Dropdown } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { StyledDropdownButton, StyledDropdownItem } from "./styles";

type CrmFieldDropdownProps = {
    appendTo: string;
    crmField: string;
    fieldPlaceholder: string;
    crmFieldOptions: readonly string[];
    onCrmFieldChange: (value: string) => void;
};

const CrmFieldDropdown = ({
    fieldPlaceholder,
    crmField,
    crmFieldOptions,
    onCrmFieldChange,
    appendTo,
}: CrmFieldDropdownProps) => (
    <Dropdown
        appendTo={appendTo}
        selectedIds={crmField ? { crmField: true } : {}}
        hasSearch
        searchPlaceHolder={translate("si.crm-enrichment.job-wizard.filters.field.search-placeholder")}
        dropdownPopupHeight={232}
        onClick={({ children }: { children: string }) => onCrmFieldChange(children)}
    >
        {[
            <StyledDropdownButton key="dd-btn">{crmField || fieldPlaceholder}</StyledDropdownButton>,
            ...crmFieldOptions.map((option, index) => (
                <StyledDropdownItem
                    key={`${index}-${option}`}
                    selected={option === crmField}
                >
                    {option}
                </StyledDropdownItem>
            )),
        ]}
    </Dropdown>
);

export default CrmFieldDropdown;
